import { ApiResponse, BASE_URL } from "server";
import {
  CheckTokenValidityInput,
  SignInInput,
  UpdateProfileImageInput,
  ChangePasswordInput,
  ChangePasswordOutput,
} from "../InputsTypes";
import {
  CheckTokenValidityOutput,
  ProfileOutput,
  SignInOutput,
  UpdateProfileImageOutput,
} from "../OutputsTypes";

// #/auth/signin
export async function signIn(
  input: SignInInput,
): Promise<ApiResponse<SignInOutput>> {
  try {
    const response = await fetch(`${BASE_URL}/auth/signin`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify(input),
      credentials: "include",
    });

    if (response.ok) {
      const data: SignInOutput = await response.json();
      return {
        status: 200,
        body: data,
      };
    } else {
      const errorData = await response.json();
      return {
        status: response.status,
        body: { message: errorData.message || "An error occurred" },
      };
    }
  } catch (error) {
    return {
      status: 500,
      body: { message: "Internal Server Error" },
    };
  }
}

// #/auth/check-token-validity

export async function checkTokenValidity(
  input: CheckTokenValidityInput,
): Promise<ApiResponse<CheckTokenValidityOutput>> {
  try {
    const response = await fetch(`${BASE_URL}/auth/check-token-validity`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify(input),
      credentials: "include",
    });

    if (response.ok) {
      const data: CheckTokenValidityOutput = await response.json();
      return {
        status: 200,
        body: data,
      };
    } else {
      const errorData = await response.json();
      return {
        status: response.status,
        body: { message: errorData.message || "An error occurred" },
      };
    }
  } catch (error) {
    return {
      status: 500,
      body: { message: "Internal Server Error" },
    };
  }
}

// #/auth/profile

export async function getProfile(): Promise<ApiResponse<ProfileOutput>> {
  try {
    const response = await fetch(`${BASE_URL}/auth/profile`, {
      method: "GET",
      headers: {
        accept: "*/*",
      },
      credentials: "include",
    });

    if (response.ok) {
      const data: ProfileOutput = await response.json();
      return {
        status: 200,
        body: data,
      };
    } else {
      const errorData = await response.json();
      return {
        status: response.status,
        body: { message: errorData.message || "An error occurred" },
      };
    }
  } catch (error) {
    return {
      status: 500,
      body: { message: "Internal Server Error" },
    };
  }
}

// #/auth/change-password

export async function changePassword(
  input: ChangePasswordInput,
): Promise<ApiResponse<ChangePasswordOutput>> {
  try {
    const response = await fetch(`${BASE_URL}/auth/change-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify(input),
      credentials: "include",
    });

    if (response.ok) {
      const data: ChangePasswordOutput = await response.json();
      return {
        status: 200,
        body: data,
      };
    } else {
      const errorData = await response.json();
      return {
        status: response.status,
        body: {
          message:
            errorData.message ||
            "Une erreur est survenue lors du changement de mot de passe",
        },
      };
    }
  } catch (error) {
    return {
      status: 500,
      body: { message: "Erreur interne du serveur" },
    };
  }
}

export async function updateProfileImage(
  input: UpdateProfileImageInput,
): Promise<ApiResponse<UpdateProfileImageOutput>> {
  try {
    const formData = new FormData();
    formData.append("file", input.file);

    const response = await fetch(`${BASE_URL}/users/profile/update`, {
      method: "POST",
      headers: {
        accept: "application/json",
      },
      body: formData,
      credentials: "include",
    });

    if (response.ok) {
      const data: UpdateProfileImageOutput = await response.json();
      return {
        status: 200,
        body: data,
      };
    } else {
      const errorData = await response.json();
      return {
        status: response.status,
        body: { message: errorData.message || "Une erreur est survenue" },
      };
    }
  } catch (error) {
    return {
      status: 500,
      body: { message: "Erreur interne du serveur" },
    };
  }
}
